import { Component, OnInit } from '@angular/core';
import { WebService } from '../../shared/services/web.service';
import { Router } from '@angular/router';
import { SecureLocalStorage } from '../../shared/services/secure-local-storage';

declare var $: any, bootbox: any;
@Component({
  selector: 'app-partner-login',
  templateUrl: './partner-login.component.html',
  styleUrls: ['./partner-login.component.css']
})
export class PartnerLoginComponent implements OnInit {
  Apiurl: string;
  searchLoginObj = new LoginObject();
  showOtp: boolean = false;
  verifyOtpData: any;
  role: any;


  constructor(private router: Router, private webService: WebService, private secureLS: SecureLocalStorage) { }

  ngOnInit() {
    
  }

  SubmitDetails() {
    this.Apiurl = "api/Authenticate/SubmitLoginDetails";
    this.webService.postData(this.Apiurl, this.searchLoginObj).subscribe((data: any) => {

      debugger;

      if (data.statusCode == 200) {
        bootbox.alert("Otp sent successfully.");
        this.showOtp = true;
      }

    })
  }

  verifyOtp() {
    this.Apiurl = "api/Authenticate/VerifyOtpforPartnerLogin";
    this.webService.postData(this.Apiurl, this.searchLoginObj).subscribe((data: any) => {

   

      debugger;
      if (data.statusCode == 200) {
        //this.role = "RM";
        //this.partnerDetails = this.secureLS.getStorage('RMTk');
        this.secureLS.setStorage('PartnerTk', data.role);
        this.secureLS.setStorage('PartnerCode', data.partnerCode);
        this.secureLS.setStorage('TokenId', data.token);
        bootbox.alert("OTP Verified Successfully.")
        this.router.navigate(['dashboard/PartnerDashboard']);
      }
      else {
        bootbox.alert("Invalid Otp");
      }
    })
  }

  ResendOtp() {
    
    this.Apiurl = "api/OtpGenerate/resendotpforPartnerLogin";
    this.webService.postData(this.Apiurl,this.searchLoginObj).subscribe((data: any) => {
        if (data.statusCode == 204) {
          bootbox.alert(data.message);
          return false;
        }
        else {
          if (data.statusCode == 200) {
            bootbox.alert({
              message: "<div class='text-center'><h6><i class='fa fa-check-circle fa-2x text-success mb-2'></i><br>OTP have been re-sent successfully to your given input.Please verify OTP</h5></div>",
              size: 'large'
            });
          }
        }

      })
  }


  
}

export class LoginObject {

  Loginname: string;
  Password: string;
  LoginOtp: number;
  EkycClientcode: string;
}
